import { makeStyles } from '@material-ui/core';
import { calculateHeight, rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const codeContainerStyles = makeStyles(theme => ({
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  backgroundWhite: {
    backgroundColor: themeColor.white,
  },
  codeContainerTitleBar: {
    color: themeColor.infoMain,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
  },
  codeContainerTitleHeaderContainer: {
    flex: 3,
    display: 'inline',
  },
  codeContainerTitleHeader: {
    color: themeColor.modalTitle,
  },
  codeContainerSubHeaderLabel: {
    paddingBottom: calculateHeight(55).stringValue,
    fontWeight: 500,
    '@media (max-height: 1080px)': {
      fontSize: rem(2.5),
    },
    '@media (max-height: 900px)': {
      fontSize: rem(2),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(2),
    },
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(2.1),
    },
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: rem(1.5),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(1.4),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(1.2),
    },
  },
  codeContainer: {
    padding: 10,
  },
  keypadContainer: {
    alignSelf: 'flex-end',
  },
  outerMostContainer: {
    width: '0',
    marginLeft: '1vh',
  },
  fitHeight: {
    height: 'fit-content',
  },
  containerAlignment: {
    alignSelf: 'flex-end',
    justifyContent: 'center',
  },
  selfAlign: {
    alignSelf: 'flex-end',
  },
  outerFlexDesign: {
    flex: '1 1 0',
  },
  flexDesign: {
    flex: 1,
  },
  cancelButton: {
    marginRight: '1.3280vh',
  },
  codeContainerHorizontalSeparator: {
    borderTop: `2px solid ${themeColor.lightgrey}`,
    width: '90%',
    marginLeft: '4vh',
    marginBottom: '2vh',
  },
  leftMargin: {
    marginLeft: '3vw',
  },
  codeContainerTitle: {
    fontWeight: 500,
    fontSize: rem(1.25),
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.75),
    },
    '@media (width: 1920px) and (height: 1080px)': {
      fontSize: rem(1.5),
    },
    paddingRight: '0.2vw',
  },
  quantityLinePieces: {
    fontWeight: 500,
    fontSize: rem(1.25),
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.75),
    },
    '@media (width: 1920px) and (height: 1080px)': {
      fontSize: rem(1.5),
    },
    alignSelf: 'center',
  },
  quantityLineColor: {
    color: themeColor.subheaderLight,
  },
  quantityLinePadding: {
    paddingRight: '0.2vw',
  },
  quantityContainerPadding: {
    padding: '2vh 0vh',
  },
  topMargin: {
    marginTop: '6vh',
  },
  itemCodeStyle: {
    fontSize: rem(1),
  },
  itemCodeText: {
    fontWeight: 500,
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.2),
    },
    '@media (width: 1920px) and (height: 1080px)': {
      fontSize: rem(1.15),
    },
  },
  descriptionStyle: {
    fontWeight: 500,
    fontSize: rem(1.25),
    '@media (width: 1600px) and (height: 1200px)': {
      fontSize: rem(1.75),
    },
    '@media (width: 1920px) and (height: 1080px)': {
      fontSize: rem(1.5),
    },
  },
  sellingContainer: {
    flexDirection: 'row',
    alignContent: 'space-between',
    flex: 1,
  },
  bottomRightButtons: {
    justifyContent: 'flex-end',
    maxWidth: '38vw',
    alignItems: 'center',
  },
  addButton: {
    maxWidth: '17.56vw',
    lineHeight: 1.1,
    margin: '0 1.3280vh',
    '&.Mui-disabled': {
      color: themeColor.rollingStone,
      background: themeColor.progressBar,
      opacity: 1,
    },
  },
  subTitleBottle: {
    fontSize: rem(1.125),
    letterSpacing: '0.45px',
    color: themeColor.subheaderLight,
    '@media (max-height: 768px)': {
      marginTop: '1vh',
    },
  },
  bottleDepositContainer: {
    flexDirection: 'row',
    alignContent: 'space-between',
    flex: 1,
    maxHeight: '72.2vh',
  },
  bottleReturnPagination: {
    height: '7.8125vh',
  },
  amountContainer: {
    flex: 1,
    marginTop: '1.302vh',
    flexDirection: 'column',
    '@media (min-width: 1366px)': {
      maxWidth: '26.354vw',
    },
    '@media (min-width: 1920px)': {
      maxWidth: '19.2vw',
    },
  },
  amount: {
    marginLeft: '0.366vw',
    padding: '0.65vh 0.366vw',
  },
  codeContainerSubContainer: {
    paddingBottom: '2.6041666666667vh',
  },
  itemCodeContainer: {
    flex: '50%',
    padding: '1vw',
    paddingInlineStart: '3vw',
  },
  departmentContainer: {
    marginTop: '1vh',
  },
  promotionsContainer: {
    borderLeft: '2px solid #E5E5E5',
    flex: '50%',
    padding: '1vw',
  },
  promotionDescription: {
    marginTop: '2vh',
  },
  qtyLineMargin: {
    marginTop: '1vh',
  },
  icon: {
    width: '1.7569546120058566vw',
    height: '3.125vh',
    filter:
      'brightness(0) saturate(100%) invert(54%) sepia(67%) saturate(390%) hue-rotate(66deg) brightness(94%) contrast(93%)',
  },
  iconPadding: {
    paddingRight: '2.1961932650073206vw',
  },
  spacing: {
    paddingBottom: '2.6041666666666665vh',
  },
  codeTitleBar: {
    letterSpacing: 0.44,
    lineHeight: 1.25,
    borderTop: `0.5vw solid ${themeColor.alert}`,
  },
  iconError: {
    color: themeColor.alert,
  },
  accordionDetails: {
    flexDirection: 'column',
    borderTop: `1px solid ${themeColor.lightgray}`,
  },
  accordionText: {
    paddingLeft: '1vw',
    lineHeight: '20px',
  },
  accordion: {
    marginBottom: '1vh',
  },
  interventionsBottomContainer: {
    height: '7.8125vh',
  },
  subTitleContainer: {
    marginTop: '6.1380208333333vh',
  },
  subTitle: {
    color: themeColor.subheaderLight,
    '@media (max-height: 768px)': {
      marginTop: '1vh',
    },
  },
  selected: {
    border: `2px solid ${theme.palette.secondary.main}`,
  },
  scrollContainerInterventions: {
    height: '90%',
    width: '100%',
  },
  scrollContainer: {
    display: 'block',
    maxHeight: '54vh',
    '@media (max-height: 576px)': {
      maxHeight: '50vh',
    },
    '@media (min-height: 1200px) and(aspect-ratio: 4/3)': {
      maxHeight: '59vh',
    },
    paddingTop: '2vh',
  },
  topSpacing: {
    alignContent: 'end',
  },

  topPadding: {
    alignContent: 'end',
    position: 'relative',
    height: '10.2%',
  },

  contentAlign: {
    alignContent: 'flex-start',
    height: '65.8%',
  },

  listItems: {
    width: '100%',
    height: 'fit-content',
  },
  tableWidth: {
    width: '100%',
  },

  buttonSpacing: {
    marginRight: '10px',
  },
  alignBottom: {
    alignContent: 'end',
    height: '8.5%',
  },
  alignStart: {
    alignContent: 'flex-start',
  },
  containerSpacingRight: {
    marginRight: '3vh',
  },
  interventionsContainer: {
    flex: '1 1 0',
    paddingBottom: '0',
  },
}));
